var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ProofreadingCategoryAccordion,
    {
      ref: "accordionRef",
      attrs: {
        label: _vm.label,
        "default-open": _vm.defaultOpen,
        "scroll-to-top-on-open": "",
      },
    },
    _vm._l(_vm.issues, function (issue, index) {
      return _c(
        "div",
        { key: issue.id, staticClass: "proofreading-category-accordion__item" },
        [
          _c(_setup.IssueItem, {
            attrs: {
              issue: issue,
              "is-active": _setup.isIssueActive(issue),
              "active-location-ids": _vm.activeIssueIds,
              "category-label": issue.issueTypeLabel,
              "default-open": index === 1,
            },
            on: {
              click: _setup.onClickIssue,
              apply: _setup.onApplyIssue,
              revert: _setup.onRevertIssue,
              "reject-toggle": _setup.onRejectToggleIssue,
              hover: _setup.onHoverIssue,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }